module Shared.Admin.LockUser

open Shared
open Illy.SafeStack
open Illy.SafeStack.Validation

type DTO = 
    {
        UserId: int 
        Reason: string option
    }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations
    
    type LockValidations = 
        | ReasonValidations of StringValidations
        | CannotLockOwnUser

    module LockValidations = 
        let toString = 
            function 
            | ReasonValidations v -> v.toString()
            | CannotLockOwnUser -> "Cannot lock your own user account."
    
    let validateDTO currentUserId dto = 
        validate {
            return! (validateString 500 true >-> LockValidations.ReasonValidations) dto.Reason
            
            return! !!(error CannotLockOwnUser)
                >>= conditional pass (fun _ -> UserId dto.UserId <> currentUserId)
                |> unwrap
        }

type FailureReason = 
    | NothingToDo
    | FailedValidations of ValidationResult<Validations.LockValidations, NoWarning>
